import {CSSProperties, FC} from 'react';


export interface IIconPlaceholderGenericV2Props {
    className?: string;
    color?: string;
    size?: string;
    style?: CSSProperties;
}

export const IconPlaceholderGenericV2: FC<IIconPlaceholderGenericV2Props> = (props) => {
    const {
        className,
        color,
        size,
        style = {},
    } = props;

    /* eslint-disable max-len */
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 19 19"
            className={className}
            fill="currentColor"
            width="1em"
            height="1em"
            style={{
                display: 'inline-block',
                flexShrink: 0,
                color,
                fontSize: size,
                lineHeight: '1em',
                ...style,
            }}
        >
            <path d="M9.5 1.188a6.539 6.539 0 0 0-6.531 6.53 6.472 6.472 0 0 0 1.316 3.92s.178.234.207.268L9.5 17.812l5.01-5.91c.027-.03.206-.264.206-.264v-.002a6.472 6.472 0 0 0 1.315-3.917A6.54 6.54 0 0 0 9.5 1.187Zm0 8.906a2.375 2.375 0 1 1 0-4.75 2.375 2.375 0 0 1 0 4.75Z" />
        </svg>
    );
};
